import { Component, Inject, ViewChild } from '@angular/core';
import { Campo, FormComponent } from '@components/form/form.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators } from '@angular/forms';
import { AlterarKmRepository } from '@app/data/alterar-km/alterar-km.repository';
import { ApiResources } from '@constants/api-resources';
import { modal } from '@shared/alerts/modal/modal.alert';

@Component({
  selector: 'app-editar-km',
  templateUrl: './editar-km.component.html',
  styleUrls: ['./editar-km.component.scss']
})
export class EditarKmComponent {

  @ViewChild('formAtualizacaoKm') formAtualizacaoKm: FormComponent | undefined = undefined;

  protected camposAtualizacaoKm: Campo[] = [
    {
      name: 'placa',
      label: 'Placa',
      type: 'text',
      width: '100%',
      disabled: true
    },
    {
      name: 'kmAtual',
      label: 'Km Atual',
      type: 'text',
      width: '100%',
      validators: [
        Validators.required,
        Validators.min((this.data.kmAtual) ? this.data.kmAtual + 1 : 0),
        Validators.max((this.data.kmAtual) ? this.data.kmAtual + 10000 : 10000)
      ],
    },
  ];

  constructor(
    private _dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private data: {
      codigoVeiculo: string,
      placa: string,
      kmAtual: number
    },
    private alterarKmRepository: AlterarKmRepository,
  ) { }

  public ngAfterViewInit(): void {
    this.formAtualizacaoKm?.patchValue({
      placa: this.data.placa
    });
  }

  putAtualizarKm() {
    let body = {
      codigoVeiculo: this.data.codigoVeiculo,
      kmAtual: this.formAtualizacaoKm?.get("kmAtual")
    };

    this.alterarKmRepository.basePath = ApiResources.VEICULOS;
    this.alterarKmRepository.putRequest<any>('', body).subscribe({
      next: () => {
        this._dialogRef.close(true);
      },
      error: (error) => {
        modal.fire({
          icon: error.icon,
          title: error.title,
          html: error.message,
        });

        this._dialogRef.close(false);
      },
    });
  }

  close() {
    this._dialogRef.close(false);
  }

}